import { formatTag, getPostsForTag, PostType } from '@space-cow-media/wp-components'
import { GetServerSidePropsContext } from 'next'

import Container from '@/components/Container/Container'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import ArticleSearch from '@/components/Wordpress/ArticleSearch/ArticleSearch'
import ArticleTypePage from '@/components/Wordpress/ArticleTypePage/ArticleTypePage'
import { ARTICLES_CACHE_CONTROL } from '@/utils/constants'

export type Props = {
  enableAdhesion: boolean
  pageCount: number
  pageNum: number
  posts: PostType[]
  tag: string
}

const ArticlesTagSubPage = ({ enableAdhesion, pageCount, pageNum, posts, tag }: Props) => (
  <Main>
    <Container>
      <div className='mx-3'>
        <SimpleHeader className='d-flex gap-3 mb-3'>
          {formatTag(tag)}
          <ArticleSearch />
        </SimpleHeader>
        <ArticleTypePage pageCount={pageCount} pageNum={pageNum} path={`tag/${tag}`} posts={posts} />
      </div>
      {enableAdhesion && <div className='mvHomeAdhesion' />}
    </Container>
  </Main>
)

export const getServerSideProps = async ({ params, res }: GetServerSidePropsContext) => {
  let page = params?.page
  const tag = params!.tag as string

  if (page === '1') {
    return {
      redirect: {
        destination: `/articles/tag/${tag}`,
        permanent: true,
      },
    }
  } else if (page === undefined) {
    page = '1'
  }

  res.setHeader('Cache-Control', ARTICLES_CACHE_CONTROL)

  const pageNum = parseInt(page as string, 10)
  const { pageCount, posts } = await getPostsForTag({ categoryId: 4, pageNum, tag })

  return {
    props: {
      enableAdhesion: true,
      pageCount,
      pageNum,
      posts,
      tag,
    },
  }
}

export default ArticlesTagSubPage
